import { makeAutoObservable } from "mobx"
import moment from "moment";
import { getSavedDates } from "../utils/IndexedDB";

class DateStore {
  fromDate = moment().startOf('month');
  toDate = moment().endOf('month');

  constructor() {
    makeAutoObservable(this)
    this.loadSavedDates();
  }

  async loadSavedDates() {
    const savedDates = await getSavedDates();
    if (savedDates) {
      this.setFromDate(moment(savedDates.startDate));
      this.setToDate(moment(savedDates.endDate));
    }
  };

  setFromDate(date: moment.Moment) {
    this.fromDate = date;
    if (date.isAfter(this.toDate)) {
      this.toDate = date.clone().endOf('month');
    }
  }

  setToDate(date: moment.Moment) {
    this.toDate = date;
    if (date.isBefore(this.fromDate)) {
      this.fromDate = date.clone().startOf('month');
    }
  }

  get isWholeMonthSelected() {
    return this.fromDate.clone().startOf('month').isSame(this.fromDate) &&
      this.toDate.clone().endOf('month').isSame(this.toDate);
  }
}

export const dateStore = new DateStore();